
import { buildPhotoSources } from "@/common/imageUrl";
import OptimizedImage from "./OptimizedImage.vue";

const GALLERY_SRCSET = [160, 240, 304, 448, 480, 640, 896, 1024, 1440, 2048];

const GALLERY_CONFIGS = {
  "splash-float": {
    getSizes() {
      return "(max-width: 768px) 90px, 230px";
    },
  },

  "splash-expanded": {
    getSizes() {
      return "90vw";
    },
  },

  "updates-card": {
    getSizes() {
      return "(max-width: 400px) 146px, (max-width: 768px) 330px, 91px";
    },
  },

  "interactive-grid": {
    getSizes(gridW = 1) {
      if (gridW === 1) return "(max-width: 1024px) 25vw, 223px";
      if (gridW === 2) return "(max-width: 1024px) 50vw, 470px";
      if (gridW === 3) return "(max-width: 1024px) 75vw, 717px";
      if (gridW === 4) return "(max-width: 1024px) 95vw, 964px";
      return "223px";
    },
  },
};

export default {
  name: "GalleryPhoto",

  components: {
    OptimizedImage,
  },

  props: {
    src: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => Object.keys(GALLERY_CONFIGS).includes(value),
    },
    gridW: {
      type: Number,
      default: 1,
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
    alt: {
      type: String,
      default: "",
    },
    loading: {
      type: String,
      default: "lazy",
    },
    priority: {
      type: String,
      default: "auto",
      validator: (value) => ["high", "auto"].includes(value),
    },
    imgClass: {
      type: [String, Object, Array],
      default: "",
    },
    pictureClass: {
      type: [String, Object, Array],
      default: "",
    },
    vImg: {
      type: [Object, Boolean],
      default: false,
    },
  },

  computed: {
    sources() {
      return buildPhotoSources(this.src, { sizes: GALLERY_SRCSET });
    },

    sizeConfig() {
      return GALLERY_CONFIGS[this.type];
    },

    computedSizes() {
      return this.sizeConfig.getSizes(this.gridW);
    },

    photoClass() {
      return ["gallery-photo", this.imgClass];
    },

    computedVImg() {
      if (this.vImg === false) return false;
      const base = typeof this.vImg === "object" ? this.vImg : {};
      return {
        ...base,
        src: this.src,
      };
    },
  },
};
